<template>
  <div>
    <section>
      <!-- Just an image -->
      <div class="outer-menu" style="z-index: 7777">
        <input class="checkbox-toggle" type="checkbox" />
        <div class="hamburger">
          <div></div>
        </div>
        <div class="menu">
          <div>
            <div>
              <ul>
                <li>
                  <router-link :to="{ name: 'home' }" class="text-white">
                    Home
                  </router-link>
                </li>
                <!-- <li><router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="text-white"> Create Store</router-link></li> -->
                <li>
                  <router-link
                    v-if="admin"
                    :to="{ name: 'admin' }"
                    class="text-white"
                  >
                    Admin</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="pageadmin"
                    :to="{ name: 'admin-services' }"
                    class="text-white"
                  >
                    Admin</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="visitor"
                    :to="{ name: 'signin' }"
                    class="text-white"
                  >
                    Sign in</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="visitor"
                    :to="{ name: 'usersignup' }"
                    class="text-white"
                  >
                    Sign up</router-link
                  >
                </li>
                <li>
                  <router-link
                    v-if="user"
                    :to="{ name: 'myaccount' }"
                    class="text-white"
                  >
                    My Account</router-link
                  >
                </li>
                <li>
                  <a
                    style="cursor: pointer"
                    @click="logout()"
                    v-if="user || admin || pageadmin"
                    class="text-white"
                  >
                    Sign out</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="">
      <section>
        <nav class="navbar" style="background-color: #180000">
          <a class="navbar-brand" href="#">
            <img src='../../static/img/logo/Logo2.jpeg' width="50" height="50" alt="eshops-logo" />
          </a>
          <div class="d-nav">
            <router-link :to="{ name: 'home' }" class="text-white mr-5">
              Home
            </router-link>
            <!-- <router-link :to="{name: 'regshop', params:{plan: 'Premium'}}" class="text-white mr-5"> Create Store</router-link> -->
            <router-link
              v-if="admin"
              :to="{ name: 'admin' }"
              class="m-link text-white mr-5"
              >Admin</router-link
            >
            <router-link
              v-if="pageadmin"
              :to="{ name: 'admin-services' }"
              class="m-link text-white mr-5"
              >Admin</router-link
            >
            <router-link
              v-if="visitor"
              :to="{ name: 'signin' }"
              class="m-link text-white mr-5"
              >Sign in</router-link
            >
            <router-link
              v-if="visitor"
              :to="{ name: 'usersignup' }"
              class="m-link text-white mr-5"
              >Sign up</router-link
            >
            <router-link
              v-if="user"
              :to="{ name: 'myaccount' }"
              class="m-link text-white mr-5"
              >My Account</router-link
            >
            <a
              style="cursor: pointer"
              @click="logout()"
              v-if="user || admin || pageadmin"
              class="text-white mr-5"
              >Sign out</a
            >
          </div>
        </nav>
      </section>
    </div>
    <div class="container mt-3 py-5">
      <div class="row col-md-8 mx-auto">
        <h3 class="text-center text-info mx-auto mb-4">TERMS OF USE</h3>
        <p align="center">
          Effective from 28 AUG 2018, the Services, as defined below will be
          provided to you by eshops.lk, the company currently providing the site
          to you. eshops.lk will also be the applicable data controller from 15
          OCT 2018.
          <br />
          <br />
          <strong>eshops.lk Terms of Use</strong>
          <br />
          <br />
        </p>
        <p align="center">
          <strong>Introduction</strong>
        </p>
        <p align="center">
          Welcome to www.eshops.lk. Thanks for stopping by. These Terms of Use,
          the
          <router-link class="text-primary" :to="{ name: 'privacypolicy' }"
            >Privacy Policy</router-link
          >, and all policies posted on our site set out the terms on which we
          offer you access to and use of our site, services, applications and
          tools. You can find an overview of our policies here. You agree to
          comply with the full Terms of Use when accessing or using our
          Services. The Terms of Use set out below take effect from 28 AUG 2018
        </p>

        <p></p>
        <p>
          <br />
          <strong>1. </strong> <strong>Your Account</strong>
        </p>
        <p>
          To access and use some of the Services, you may need to register with
          us and set up an account with your email address and a password (your
          “Account”). The email address you register with will be your email
          address, and you are solely responsible for maintaining the
          confidentiality of your password. You are solely responsible for all
          activities that happen under your Account.
        </p>
        <p>
          You may connect to the Services with a third-party service (e.g.
          Facebook or Google+) and you give us permission to access, store, and
          use your information from that service as permitted by that service
          and as may be described in our
          <router-link class="text-primary" :to="{ name: 'privacypolicy' }"
            >Privacy Policy</router-link
          >. If you believe your Account has been compromised or misused,
          contact us immediately at eshops.lk customer support.
          <br />
        </p>
        <p><strong> 2.</strong> <strong>Using eshops.lk. </strong></p>
        <p>
          To use the Services, you must be over 18 years old. You agree that you
          will post in the appropriate category or area and you agree that you
          will not do any of the following bad things:
        </p>
        <div class="prv-ul">
          <p>
            <li>Violate any laws or the posting rules.</li>
          </p>
          <p>
            <li>
              any threatening, abusive, defamatory, obscene or indecent
              material;
            </li>
          </p>
          <p>
            <li>be false or misleading;</li>
          </p>
          <p>
            <li>infringe any third-party right;</li>
          </p>
          <p>
            <li>
              distribute or send communications that contain spam, chain
              letters, or pyramid schemes;
            </li>
          </p>
          <p>
            <li>
              distribute viruses or any other technologies that may harm
              eshops.lk, the Services or the interests or property of eshops.lk
              users;
            </li>
          </p>
          <p>
            <li>
              impose an unreasonable load on our infrastructure or interfere
              with the proper working of the Services;
            </li>
          </p>
          <p>
            <li>
              copy, modify, or distribute any other person’s content without
              their consent;
            </li>
          </p>
          <p>
            <li>
              use any robot spider, scraper or other means to access the
              Services and collect content for any purpose without our express
              written permission;
            </li>
          </p>
          <p>
            <li>
              harvest or otherwise collect information about others, including
              email addresses, without their consent; and/or
            </li>
          </p>
          <p>
            <li>
              Bypass measures used to prevent or restrict access to the
              Services.
            </li>
          </p>
        </div>
        <p class="">
          <strong>3. </strong>
          <strong>Abusing eshops.lk Services</strong>
        </p>
        <p>
          eshops.lk and the eshops.lk community work together to keep the
          Services working properly and the community safe. Please report
          problems, offensive content and policy breaches to us using the
          reporting system. You are solely responsible for all information that
          you give to eshops.lk and any consequences that may result from your
          posts. We can at our discretion refuse, delete or take down content
          that we think is inappropriate or breaching these Terms of Use. We
          also can at our discretion restrict a user’s usage of the Services
          either temporarily or permanently, or refuse a user’s registration.
          Without limiting other remedies, we may issue warnings, limit or
          terminate our Services, remove hosted content and take technical and
          legal steps to keep users off the Services if we think that they are
          creating problems or acting inconsistently with the letter or spirit
          of our policies. However, whether we take any of these steps, we don’t
          accept any liability for monitoring the Services or for un-authorized
          or unlawful content on the Services or use of the Services by users.
          You also accept that eshops.lk is not under any obligation to monitor
          any data or content which is submitted to or available on the
          Services. ​​​
        </p>
        <p><strong>4.</strong> <strong>Fees and Services.</strong></p>
        <p>
          We sometimes charge a fee for certain features or Services. If the
          feature you use incurs a fee, you will be able to review and accept
          that charge before purchase. Our fees are quoted in Sri Lankan rupees,
          and we may sometimes change them. We’ll notify you of changes to our
          fees by posting the changes on the site.
        </p>
        <p>
          We may sometimes temporarily change our fees for testing purposes,
          promotional events or new features, these changes take effect from the
          time the price change is posted to the site. Our fees are
          non-refundable after the feature is supplied, and you are responsible
          for paying them when they are due. If you don’t, we may limit your
          ability to use the Services. If your payment method fails or your
          account is past due, we may collect fees owed using collection
          mechanisms, including third party debt collection services.
        </p>
        <p>
          You agree to provide accurate information necessary for eshops.lk to
          comply with our obligations under applicable law. You are solely
          responsible for collecting and remitting any applicable taxes
          resulting from the sale of your items or services listed on
          eshops.lk’s Services.
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong>5. </strong>
          <strong>Content</strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          eshops.lk’s Services contain content from us, you, and other users.
          eshops.lk is protected by copyright laws and international treaties.
          Content displayed on or via the Services is protected as a collective
          work and/or compilation, pursuant to copyrights laws and international
          conventions. You agree not to copy, distribute the Services or modify
          content from the Services, our trademarks or copyrights without our
          express written consent. You may not disassemble or decompile, reverse
          engineer or otherwise attempt to discover any source code contained in
          the Services. Without limiting the foregoing, you agree not to
          reproduce, copy, sell, resell, or exploit for any purposes any aspect
          of the Services (other than your own content).
        </p>
        <p>
          When you give us content, including pictures, you grant us and
          represent that you have the right to grant us, a non-exclusive,
          worldwide, perpetual, irrevocable, royalty-free, sub-licensable
          (through multiple tiers) right to exercise any and all copyright,
          publicity, trademarks, design, database and intellectual property
          rights to that content, in any media whether now known or to be
          discovered in the future, including third party sites and
          applications. You also waive all moral rights you have in the content
          to the fullest extent permitted by law. We reserve the right to remove
          content where we have grounds for suspecting the violation of these
          terms or the rights of any other party
        </p>
        <p>
          <strong>6. </strong>
          <strong>
            Reporting Intellectual Property Infringements (Verified Rights
            Owners)
          </strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong> </strong>
          Do not post content that infringes the rights of third parties. This
          includes, but is not limited to, content that infringes on
          intellectual property rights such as copyright and trademark (e.g.
          offering counterfeit items for sale). We can remove content where we
          have grounds for suspecting the violation of these terms, our policies
          or of any party’s rights. If you have a good faith belief that a
          listing on any of the Services infringes your copyright, trademark, or
          other intellectual property rights, all you need to do is contact the
          customer service of eshops.lk. Only the intellectual property rights
          owner can report potentially infringing items or listings through
          eshops.lk’s VERO Program. After we receive your first notice,
          eshops.lk will confirm your enrolment in our program and send you the
          instructions on how to submit future reports electronically. We can
          share and discuss, in accordance with applicable law, the investigated
          issue with the third party that originally posted the potentially
          infringing listing.
        </p>
        <p>
          <strong>7. </strong>
          <strong>Third Party services on eshops.lk</strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          You may use the PayPal payment gateway for some financial transactions
          on our Services. When you link your PayPal account to your Account,
          you can use your PayPal account to pay or be paid for items by buyers
          or sellers while using eshops.lk’s Services. You acknowledge and agree
          that by utilizing any third party services through our Services (such
          as PayPal), you are bound by the terms and conditions of that third
          party and we are not liable for any loss, claims or damages howsoever
          arising in connection with that third party’s services.
        </p>
        <p>
          If you to link your PayPal account to your Account you appoint
          eshops.lk as your limited agent to:
        </p>
        <p>
          a. provide to PayPal your name, address, payment amount, item details,
          item category, and all other information required by PayPal to enable
          PayPal to process payments to or from your PayPal account , and
        </p>
        <p>
          b. receive payment confirmation and decline notices from PayPal in
          respect of your PayPal payment transactions.
        </p>
        <p>
          <br />
          When you link your PayPal account to your eshops.lk Account, we accept
          our appointment as your limited agent to undertake those activities
          specified in the paragraph above. Our appointment as your agent to
          undertake these activities terminates immediately upon your Account
          ceasing to be linked to your PayPal account.
          <br />
        </p>
        <p>
          eshops.lk is not able to access your complete financial details from
          PayPal or your PayPal account. At no time does eshops.lk hold any of
          the funds when a buyer pays a seller using PayPal. Funds are
          transferred directly by PayPal from the buyer’s PayPal account to the
          seller’s PayPal account after the deduction by PayPal of any relevant
          PayPal fees. PayPal's terms and conditions apply to your use of PayPal
          when you access PayPal’s services from our Services, and you must
          agree to PayPal’s terms and conditions in order to use the PayPal’s
          services.
        </p>
        <p>
          You acknowledge and agree that, to the extent permitted by law, we are
          not liable to you for any loss or damage you incur arising from your
          use of the PayPal method, unless such loss or damage was as a direct
          result of eshops.lk’s error, in which case our liability is limited in
          accordance with.
          <br />
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p><strong> 8. </strong><strong>Legal and Financial Advice</strong>.</p>
        <p>
          You acknowledge and agree that you have the opportunity to obtain
          independent legal and financial advice from appropriately qualified
          professional advisers and that you take into account your personal
          objectives, financial situation and needs before buying or selling an
          item via our Services.
        </p>
        <p>
          You acknowledge and agree that the information provided by eshops.lk
          in relation to using PayPal’s services is factual in nature only and
          eshops.lk has not provided a recommendation or statement of opinion
          intended to influence your decision on whether or not to use PayPal’s
          services and that you cannot rely on any of eshops.lk’s advertising
          materials, terms, instructions or policies as a recommendation,
          statement of opinion or financial product advice.
          <br />
        </p>
        <p>
          <strong>9. </strong>
          <strong>Limitation of Liability. </strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          <strong> </strong>
          Nothing in these Terms of Use excludes, restricts or modifies any
          rights or statutory guarantees that you may have under applicable laws
          that cannot be excluded, restricted or modified, including any such
          rights or statutory guarantees under the applicable Consumer Laws. To
          the extent that these Terms of Use are found to exclude, restrict or
          modify any such rights or statutory guarantees, those rights and/or
          statutory guarantees prevail to the extent of the inconsistency.
        </p>
        <p>
          Services are provided “as is” and “as available”. You agree not to
          hold us responsible for things other users post or do. As most of the
          content on the Services comes from other users, we do not guarantee
          the accuracy of postings or user communications or the quality,
          safety, or legality of what is offered.
        </p>
        <p>
          We also cannot guarantee continuous or secure access to our Services.
          While we will use reasonable efforts to maintain an uninterrupted
          service, we cannot guarantee this and, to the extent permitted by law,
          we do not give any promises or warranties (whether express or implied)
          about the availability of our Services or that the Services will be
          uninterrupted or error-free.
        </p>
        <p>
          Notification functionality in the Services may not occur in real time.
          That functionality is subject to delays beyond our control, including
          without limitation, delays or latency due to your physical location or
          your wireless data service provider’s network. To the extent permitted
          by law, we are not liable for the posting of any unlawful,
          threatening, abusive, defamatory, obscene or indecent information, or
          material of any kind by a user of the Service which violates or
          infringes upon your rights, including without limitation any
          transmissions constituting or encouraging conduct that would
          constitute a criminal offense, give rise to civil liability or
          otherwise violate any applicable law.
        </p>
        <p>
          eshops.lk excludes any liability to you for any loss or damage
          suffered by you as a result of using eshops.lk if the loss or damage
          was not reasonably foreseeable and was not directly cased by
          eshops.lk.
          <br />
        </p>
        <p>
          <strong>10. </strong>
          <strong>Indemnification</strong>
        </p>
        <p>
          <strong></strong>
        </p>
        <p>
          You will indemnify and hold harmless eshops.lk and our affiliates and,
          our and their respective officers, directors, agents and employees
          (each an “Indemnified Party”), from any claim made by any third party,
          together with any amounts payable to the third party whether in
          settlement or as may otherwise be awarded, and reasonable legal costs
          incurred by any of the Indemnified Parties, arising from or relating
          to your use of the Services, any alleged violation by you of the
          applicable terms, and any alleged violation by you of any applicable
          law or regulation. We reserve the right, at our own expense, to assume
          the exclusive defense and control of any matter subject to
          indemnification by you, but doing so will not excuse your indemnity
          obligations.
        </p>
        <p>
          <strong>11. </strong>
          <strong>Release </strong>
        </p>
        <p>
          If you have a dispute with one or more eshops.lk users, you release us
          (and our officers, directors, agents, subsidiaries, joint ventures and
          employees) from any and all claims, demands and damages (actual and
          consequential) of every kind and nature, known or unknown, arising out
          of or in any way connected with such disputes.
        </p>
        <p>
          <strong>12. </strong>
          <strong>Personal Information</strong>
        </p>
        <p>
          <strong> </strong>
          By using the Services, you agree to the collection, transfer, storage
          and use of your personal information by us (the “data controller”) on
          our servers.
        </p>
        <p>
          <strong>13. </strong>
          <strong>Severability</strong>
        </p>
        <p>
          If a provision of these Terms of Use is illegal or unenforceable in
          any relevant jurisdiction, it may be severed for the purposes of that
          jurisdiction without affecting the enforceability of the other
          provisions of these Terms of Use.
        </p>
        <p>
          <strong>14. </strong>
          <strong>General</strong>
        </p>
        <p>
          These Terms of Use and the other policies posted on the Services set
          out the entire agreement between eshops.lk and you, overriding any
          prior agreements. From 28 AUG 2018, this agreement is governed by the
          laws of Sri Lanka.
        </p>
        <p>
          We both submit to the non-exclusive jurisdiction of the courts of Sri
          Lanka. If we don’t enforce any particular provision, we are not
          waiving our right to do so later. If a court strikes down any of these
          Terms of Use, the remaining terms will survive.
        </p>
        <p>
          We may, automatically assign this agreement in our sole discretion in
          accordance with the notice provision below (our assignment to an
          affiliate will not require notice). Except for notices about illegal
          or infringing content, your notices to us must be sent by registered
          mail.
        </p>

        <p>
          We will send notices to you via the email address you provide, or by
          registered mail. Notices sent by registered mail will be deemed
          received five days following the date of mailing.
        </p>
        <p>
          We may update this agreement at any time, with updates taking effect
          when you next use the site or after 30 days, whichever is sooner. No
          other amendment to this agreement will be effective unless made in
          writing, signed by you and by us.
        </p>

        <p>
          <strong>15. </strong>
          <strong>Mobile Devices Terms</strong>
        </p>
        <p>
          If you’re accessing eshops.lk Services from a mobile device using a
          eshops.lk Mobile Application (the “Application”), the following terms
          and conditions apply to you in addition to the applicable Mobile
          Privacy and Legal Notice or End User License Agreement, as the case
          may be. Your use of the Application confirms your agreement to these
          Mobile Devices Terms.
        </p>
        <p>a. <strong>Application Use</strong></p>
        <p>
          eshops.lk grants you the right to use the Application only for your
          personal use. You must comply with all applicable laws and third party
          terms of agreement when using the Application (e.g. your wireless data
          service agreement). The Application may not contain the same
          functionality available on the www.eshops.lk.com Website. Your
          download and use of the Application is at your own discretion and
          risk, and you are solely responsible for any damages to your hardware
          device(s) or loss of data that result from the download or use of the
          Application.
        </p>
        <p>b. <strong>Intellectual Property – Applications</strong></p>
        <p>
          <strong> </strong>
          eshops.lk owns, or is the licensee to, all right, title, and interest
          in and to its Applications, including all rights under patent,
          copyright, trade secret, trademark, and any and all other proprietary
          rights, including all applications, renewals, extensions, and
          restorations thereof. You will not modify, adapt, translate, prepare
          derivative works from, decompile, reverse-engineer, disassemble, or
          otherwise attempt to derive source code from any Application and you
          will not remove, obscure, or alter eshops.lk’s copyright notice,
          trademarks or other proprietary rights notices affixed to, contained
          within, or accessed in conjunction with or by any eshops.lk
          Application.
        </p>
        <p><strong>16.</strong> <strong>Additional Terms. </strong></p>
        <p>
          Additional terms and conditions that apply to you based on the mobile
          device the Application is installed on
        </p>
        <p>
          <strong></strong>
        </p>
        <ul>
          <br />
          <li class="prv-li">
            <strong>iOS – Apple</strong>
          </li>
        </ul>

        <p>
          1. These Mobile Devices Terms are an agreement between you and
          Gumtree, and not with Apple. Apple is not responsible for the
          Application and the content thereof.
        </p>
        <p>
          2. Gumtree grants you the right to use the Application only on an iOS
          product that you own or control and as permitted by the Usage Rules
          set forth in the App Store Terms of Service.
        </p>
        <p>
          3. Apple has no obligation whatsoever to furnish any maintenance and
          support services with respect to the Application.
        </p>
        <p>
          4. Apple is not responsible for the investigation, defense,
          settlement, and discharge of any third party intellectual property
          infringement claim.
        </p>
        <p>
          5. Apple is not responsible for addressing any claims by you or any
          third party relating to the Application or your possession and/or use
          of the Application, including but not limited to
        </p>
        <p>(a) Product liability claims</p>
        <p>
          (b) Any claim that the Application fails to conform to any applicable
          legal or regulatory requirement
        </p>
        <p>
          (c) claims arising under consumer protection or similar legislation.
        </p>
        <p>
          6. In the event of any failure of the Application to conform to any
          applicable warranty, you may notify Apple, and Apple will refund the
          purchase price, if applicable, for the Application to you; and to the
          maximum extent permitted by applicable law, Apple will have no other
          warranty obligation whatsoever with respect to the Application.
        </p>
        <p>
          7. Apple and Apple’s subsidiaries are third party beneficiaries of
          these Mobile Devices Terms, and, upon your acceptance, Apple as a
          third party beneficiary thereof will have the right (and will be
          deemed to have accepted the right) to enforce these Mobile Devices
          Terms against you.
        </p>
        <p>
          <strong></strong>
        </p>
        <ul>
          <li class="prv-li">
            <strong>Windows – Microsoft</strong>
          </li>
        </ul>
        <p>
          1. These Mobile Devices Terms are an agreement between you and
          eshops.lk, not Microsoft. The terms of use and privacy policies of
          Microsoft and, where applicable, the network operators that provide
          billing services for the Windows Phone Marketplace do not apply to
          your use of the Application.
        </p>
        <p>
          2. You may install and use one (1) copy of the Application on up to
          five (5) devices you personally own or control and which are
          affiliated with the Windows Live ID associated with your Windows
          Marketplace account. You may not install or use a copy of the
          Application on a device you do not own or control.
        </p>
        <p>
          3. Microsoft, your device manufacturer, and (if applicable) your
          wireless carrier are not responsible for providing support services
          for the Application.
        </p>
        <p>
          4. Microsoft, the wireless carriers over whose network the Application
          is distributed (if applicable), and each of their respective
          affiliates and suppliers (collectively, “Disclaiming Distributors”)
          give no express warranty, guarantee, or conditions under or in
          relation to the Application. To the extent permitted under your local
          laws, the Disclaiming Distributors exclude any implied warranties or
          conditions, including those of merchantability, fitness for a
          particular purpose, and non-infringement.
        </p>
        <p>
          5. You, and not the Disclaiming Distributors, bear the risk of using
          the Application (even if the Disclaiming Distributors have been
          advised of the possibility of damages to you). You may have additional
          consumer rights under your local laws which these Mobile Devices Terms
          cannot change.
        </p>
        <p>
          6. To the extent not prohibited by law, you will not seek to recover
          any consequential, lost profit, special, indirect, or incidental
          damages from any Disclaiming Distributor.
        </p>
      </div>
    </div>

    <footer class="footer section section-sm">
      <!-- Container Start -->
      <div class="container">
        <div class="row justify-content-around">
          <!-- <div class="col-lg-3 col-md-7 offset-md-1 offset-lg-0">
        
        <div class="block about">
         
          <img src="images/logo-footer.png" alt="">
          
          <p class="alt-color text-secondary">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
        </div>
         <ul class="social-media-icons mb-3">
              <li><a class="fa fa-facebook" href=""></a></li>
              <li><a class="fa fa-twitter" href=""></a></li>
              <li><a class="fa fa-pinterest-p" href=""></a></li>
              <li><a class="fa fa-vimeo" href=""></a></li>
            </ul>
      </div> -->
          <!-- Link list -->
          <div class="col-sm-6 col-lg-3">
            <div class="block block-link">
              <h4>Site Pages</h4>
              <ul>
                <li class="px-0">
                  <router-link :to="{ name: 'home' }">Home</router-link>
                </li>
                <!-- <li><router-link :to="{name: 'regshop', params:{plan: 'Premium'}}">Create Store</router-link></li> -->
                <li>
                  <router-link :to="{ name: 'about' }">About Us</router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'termsofuse' }"
                    >Terms of Use</router-link
                  >
                </li>
                <li>
                  <router-link :to="{ name: 'privacypolicy' }"
                    >Privacy Policy</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <!-- Link list -->
          <div class="col-sm-6 col-lg-4">
            <div class="block block-info">
              <h4>Contact Us</h4>
              <ul>
                <li>
                  <a
                    ><i class="fa fa-phone mr-2" aria-hidden="true"></i>0719 500
                    600</a
                  >
                </li>
                <!-- <li>
                  <a
                    ><i class="fa fa-phone mr-2" aria-hidden="true"></i
                    >0113-601-444</a
                  >
                </li> -->
                <li>
                  <a
                    ><i class="fa fa-envelope mr-2" aria-hidden="true"></i
                    >info@eshops.lk</a
                  >
                </li>
              </ul>
              <ul class="social-media-icons mb-2 d-inline">
                <li style="">
                  <a
                    href="https://www.facebook.com/Eshopslk-2212428785713128/"
                    class="px-0 ml-0 mr-2"
                    ><i
                      class="fa fa-facebook-official f-sm-link"
                      style="
                        font-size: 34px;
                        color: #3b5998;
                        background-color: #fff;
                        width: 30px;
                        height: 30px;
                        border-radius: 4px;
                        text-align: center;
                        vertical-align: middle;
                      "
                    ></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/eshops.lk/"
                    class="px-0 mx-2"
                    ><i
                      class="fa fa-instagram f-sm-link"
                      style="
                        font-size: 30px;
                        color: #fff;
                        background: #d6249f;
                        background: radial-gradient(
                          circle at 30% 107%,
                          #fdf497 0%,
                          #fdf497 5%,
                          #fd5949 45%,
                          #d6249f 60%,
                          #285aeb 90%
                        );
                        width: 32px;
                        height: 32px;
                        border-radius: 4px;
                        text-align: center;
                        vertical-align: middle;
                      "
                    ></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"
                    class="px-0 mx-2"
                    ><i
                      class="fa fa-youtube-square f-sm-link"
                      style="
                        font-size: 35px;
                        color: #ff0000;
                        background-color: #fff;
                        width: 30px;
                        height: 30px;
                        border-radius: 6px;
                        text-align: center;
                        vertical-align: middle;
                      "
                    ></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <!-- Promotion -->
          <div class="col-sm col-md-8 col-lg-5">
            <!-- App promotion -->
            <div class="block-2 app-promotion">
              <a>
                <!-- Icon -->
                <img
                  src="../../static/img/icons/footer-android-chrome-90x90.png"
                  alt="mobile-icon"
                />
              </a>
              <p class="m-f-text">
                Tap the Add to Home Screen Tab in Chrome Browser on Android or
                Safari Browser on IOS to Get the Splendid
                <span style="color: #fd6a02; font-size: 20px">Mobile App</span>
                Directly
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Container End -->
    </footer>
    <!-- Footer Bottom -->
    <footer class="footer-bottom">
      <!-- Container Start -->
      <div class="container">
        <div class="row">
          <div class="col-12 mx-auto mt-5">
            <div class="copyright text-center mx-auto">
              <img src="../../static/img/eshops-logo.png" alt="eshops-logo" />
              <p class="m-f-text text-center mt-2">
                © {{ new Date().getFullYear() }} eshops.lk | All Rights Reserved
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- Container End -->
      <!-- To Top -->
    </footer>
    <!-- <back-to-top bottom="50px" right="50px">
  <button type="button" class="btn btn-info btn-to-top"><i class="fa fa-chevron-up"></i></button>
</back-to-top> -->
  </div>
</template>

<script>
import db from "../config/FirebaseInit";
import firebase from "firebase/app";
export default {
  name: "termsofuse",
  data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      starterplanadmin: false,
      pageadmin: false,
    };
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/");
        });
    },

    scrollWin() {
      window.scrollBy(0, 800);
    },
  },
  created() {
    if (firebase.auth().currentUser) {
      if (firebase.auth().currentUser.displayName == null) {
        this.user = true;
      } else if (
        firebase.auth().currentUser.displayName == "shop owner" ||
        firebase.auth().currentUser.displayName == "starterplan shop owner"
      ) {
        this.admin = true;
      } else if (firebase.auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      }
    } else {
      this.visitor = true;
    }

    this.$nextTick(function () {
      //this.initToTopButton();
    });
  },
};
</script>

<style scoped>
@import url("~@/assets/main/css/styles.css");
@import url("~@/assets/main/css/nav.css");

.goTop {
  cursor: pointer;
  border-radius: 5px;
  background-color: rgb(1, 14, 27);
  background-color: rgba(1, 14, 27, 0.7);
  position: fixed;
  width: 45px;
  height: 45px;
  display: block;
  right: 15px;
  bottom: 15px;
  border: none;
  opacity: 0;
  z-index: -1;
}
.isVisible {
  opacity: 0.8;
  z-index: 4;
  transition: all 0.4s ease-in;
}
@media (max-width: 767px) {
  .d-nav {
    display: none;
  }
}
@media (max-width: 575px) {
  .m-link {
    font-size: 14px;
  }
  .m-f-text {
    font-size: 12px;
  }
  .footer .block ul li a {
    font-size: 12px;
  }
}
strong {
  color: black;
  font-weight: 600;
}
p {
  margin: 5px 0;
  text-align: justify;
  color: #011;
}
.prv-ul li {
  list-style-type: square;
}
</style>



// WEBPACK FOOTER //
// src/components/TermsOfUse.vue